/**
 * Profile-fetch coordination for AuthContext.
 * Avoid awaiting Supabase queries inside onAuthStateChange — GoTrue's navigator
 * lock deadlocks the SELECT and surfaces as "Profile fetch timeout".
 */

export function shouldSkipDuplicateProfileFetch(args: {
  force: boolean;
  retryCount: number;
  inProgress: boolean;
  lastFetchedUserId: string | null;
  userId: string;
}): boolean {
  // Retries of the same logical fetch must proceed; only skip rival root calls.
  if (args.force || args.retryCount > 0) return false;
  return args.inProgress && args.lastFetchedUserId === args.userId;
}

/** Run after GoTrue releases its auth callback lock. */
export function scheduleAfterAuthCallback(fn: () => void): void {
  setTimeout(fn, 0);
}
